import React from 'react';
import { connect } from 'react-redux';
import {Translate, I18n} from 'react-redux-i18n';
import {
    Checkbox,
    Dialog,
    InputGroup,
    TextArea,
} from '@blueprintjs/core';
import axios from 'axios';

import {
    closeContributeBenchmarkDialog as closeContributeBenchmarkDialogAction
} from './ExerciseBenchmarkActions';

import {
    openThankyouDialog as openThankyouDialogAction
} from '../MutualAid/MutualAidActions';


class ContributeDialog extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.nameRef = React.createRef();
        
        this.state = {
            name: "",
            description: "",
            serviceAgreement: false,
            submitting: false,
            error: "",
            categories: [],
            selectedCategories: [],
        }
    }
    
    componentDidMount() {
      (async ()=>{
        const response = await axios.get('/api/category', {
            headers: {
                'Authorization': window.localStorage.getItem("token")
            }
        })
        this.setState(({categories: response.data.categories}));
      })()
    }
    
    handleSubmit = () => {
        if(!this.state.description) {
            return this.setState({error: "Evaluation description missing"});
        }
        if(this.state.selectedCategories.length === 0) {
            return this.setState({error: "Evaluation category missing"});
        }
        
        this.setState({submitting: true}, async () => {
            try {
                const response = await axios.post('/api/companies/benchmarks/contribute', {
                        _id: this.props.currentBenchmarks[0]._id,
                        name: this.state.name || this.props.currentBenchmarks[0].name,
                        description: this.state.description,
                        categories: this.state.selectedCategories,
                    }, {
                        headers: {
                            'Authorization': window.localStorage.getItem("token")
                        }
                    }
                );
                
                if(response.status >= 400) {
                    return this.setState({submitting: false, error: response.data.error || "Something went wrong"});
                }
                this.props.closeContributeBenchmarkDialog();
                this.props.openThankyouDialog();
            } catch (err) {
                console.error(err);
                this.setState({submitting: false});
            }
        })
    }
    
    render() {
        return (
            this.props.isContributeBenchmarkDialogOpen &&
            <Dialog
                autoFocus={true}
                canEscapeKeyClose={true}
                canOutsideClickClose={true}
                enforceFocus={true}
                isOpen={this.props.isContributeBenchmarkDialogOpen}
                usePortal= {true}
                onClose={this.props.closeContributeBenchmarkDialog}
                title={<span style={{color: 'white'}}><Translate value="exercise.ContributeBenchmark" /></span>}
            >
                <div className="column" style={{padding: '20px 20px 0px 20px'}}>
                    {
                        this.state.error && <div style={{color: 'red', textAlign: 'center'}}>{this.state.error}</div>
                    }
                    <InputGroup
                        onChange={(event)=>{event.persist(); this.setState({name: event.target.value})}}
                        placeholder={`Name (default: "${this.props.currentBenchmarks[0]?.name}")`}
                    />
                    <TextArea
                        onChange={(event)=>{
                            event.persist();
                            this.setState({description: event.target.value});
                        }}
                        placeholder="Description"
                        value={this.state.description}
                        style={{margin: '5px 0px'}}
                    />
                    <span className="row wrap" style={{padding: '20px'}}>
                    {
                        this.state.categories.filter((category)=>!category.parent).map((category)=>(
                            <div style={{width: '50%', marginBottom: 30}} key={"div-"+category._id}>
                                <Checkbox 
                                    key={category._id}
                                    label={category.name} 
                                    checked={this.state.selectedCategories.includes(category._id)} 
                                    onChange={
                                        (event)=>{
                                            event.persist();
                                            event.target.checked? 
                                            this.setState((prevState)=>({
                                                selectedCategories: prevState.selectedCategories.concat(category._id)
                                        // to select parent cat as well: selectedCategories: prevState.selectedCategories.concat(category._id, ...prevState.categories.filter((cat)=>cat.parent === category._id).map((cat)=>cat._id))
                                        
                                            }))
                                            : 
                                            this.setState((prevState)=>({selectedCategories: prevState.selectedCategories.filter((cat)=> cat !== category._id)})) 
                                        // to select parent cat as well: setState((prevState)=>({...prevState, selectedCategories: prevState.selectedCategories.filter((cat)=> cat !== category._id && prevState.categories.find((c)=>c._id === cat).parent !== category._id)})) 
                                        
                                        }
                                    }
                                />
                                <div style={{paddingLeft: '15px'}}>
                                {
                                    this.state.categories
                                    .filter((cat)=>cat.parent === category._id)
                                    .map((cat)=>(
                                        <Checkbox 
                                            key={cat._id}
                                            label={cat.name} 
                                            checked={this.state.selectedCategories.includes(cat._id)} 
                                            onChange={
                                                (event)=>{
                                                    event.persist();
                                                    event.target.checked? 
                                                    this.setState((prevState)=>({selectedCategories: prevState.selectedCategories.concat(cat._id, cat.parent)})) 
                                                    
                                                    : 
                                                    this.setState((prevState)=>({selectedCategories: prevState.selectedCategories.filter((word)=> word !== cat._id)})) 
                                                }
                                            }
                                        />  
                                    ))
                                }
                                </div>
                            </div>
                        ))
                    }
                    </span>
                    <Checkbox 
                        label={<a href="https://simsushare.com/eula" target="_blank"><Translate value="mutualAid.agreeToTerms" /></a>} 
                        checked={this.state.serviceAgreement} 
                        onChange={
                            (event)=>{
                                event.persist();
                                this.setState((prevState)=>({...prevState, serviceAgreement: event.target.checked}))
                            }
                        }
                    />
                    <button className={`btn btn-primary`} style={{marginTop: 10}} onClick={this.handleSubmit} disabled={this.state.submitting || !this.state.serviceAgreement}>
                      <i className="fas fa-fw fa-share-alt"/> <Translate value="scenarios.SubmitContribution"/>
                    </button>
                </div>
            </Dialog>
        )
    }
    
}

const mapStateToProps = (state)=>({
    isContributeBenchmarkDialogOpen: state.exerciseBenchmark.isContributeBenchmarkDialogOpen,
    benchmark: state.exercise.benchmark,
    currentBenchmarks: state.exerciseBenchmark.currentBenchmarks,
});

const mapDispatchToProps = ({
    closeContributeBenchmarkDialog: closeContributeBenchmarkDialogAction,
    openThankyouDialog: openThankyouDialogAction
})

export default connect(mapStateToProps, mapDispatchToProps)(ContributeDialog);